export default {
    home: {
        headingText: 'Hello world!',
        bodyText: 'This is a POC for Vue 3 component library',
        signIn: 'Sign in',
        home: 'Home',
        menu: {
            title: 'Menu',
            tos: 'Terms of Service',
            privacy: 'Privacy Policy',
            privacyLink: 'https://yellowcard.io/privacy-policy/',
            tosLink: 'https://yellowcard.io/legal/widget-terms/',
            support: 'Contact Support',
            supportLink: 'mailto:customersupport@yellowcard.io',
            signOut: 'Sign out',
            profile: 'Profile',
            verificationStatus: 'Verification Status',
            payoutAccounts: 'Payout Accounts',
        },
        buyCrypto: {
            pay: {
                placeholder: 'max',
                label: 'Pay',
            },
            receive: {
                placeholder: '',
                label: 'You will receive (approx.)',
            },
        },
        sellCrypto: {
            sell: {
                placeholder: 'max 100,000',
                label: 'Sell',
            },
            receive: {
                placeholder: '',
                label: 'You will receive (approx.)',
            },
            title: 'Sell',
            subtitle: 'The sell function is currently not available.',
        },
        currencyConverter: {
            label: 'Current Rate',
            timerLabel: 'Rate will refresh in ',
        },
        footer: {
            message: 'Powered by Yellow Card',
        },
        mobileMoney: {
            confirm: 'Confirm mobile money account details',
        },
        kyc: {
            pending: {
                title: 'Verification in progress',
                checkStatus: 'Check your verification status',
                subtitle: 'Our team is processing your verification. We’ll let you know by email when you can continue to deposit and buy.',
            },
            verified: {
                title: 'Verification approved',
                subtitle: 'You can now choose which coins you want to trade',
            },
            failed: {
                title: 'You failed our verification',
                subtitle: "There was a problem with your ID details so we couldn't verify your account. Ensure that you choose the correct ID type that matches what you have, and that you enter the ID number correctly.",
                retry: 'Retry my verification',
            },
        },
        transactions: {
            noTransactions: {
                first: 'You do not have any transactions',
                second: 'to show here',
            },
        },
        profile: {
            memberSince: 'Member Since',
            tier: 'Current Tier',
            dailyBuyLimit: 'Daily Buy Limit',
            lifetimeBuyLimit: 'Lifetime Buy Limit',
            dailySellLimit: 'Daily Sell Limit',
            lifetimeSellLimit: 'Lifetime Sell Limit',
        },
        transactionDetails: {
            status: 'Status',
            transactionFee: 'Transaction Fee',
            rate: 'Rate',
            paymentMethod: 'Payment Method',
            transactionId: 'Transaction ID',
            timestamp: 'Timestamp',
        },
        pendingDeposit: {
            notFound: {
                title: 'Sorry about this!',
                subtitle: "We're not sure what went wrong with your deposit request. Please try again in a few minutes.",
            },
            mobile: {
                find: 'Finding your deposit',
                found: 'Deposit found',
                transfer: 'This transfer can take a few minutes to complete.',
                notFound: 'Deposit not found',
                notFoundMessage: 'If you have made your deposit and you believe this is inaccurate, please contact support with your proof of payment',
            },
            bank: {
                first: "We'll let you know when we receive the deposit from your bank so you can continue. This usually takes a few minutes.",
                second: "If you've still not made your deposit, check your email for our bank details.",
            },
        },
        orderSent: {
            title: 'Thanks for your time!',
            subtitle: "You'll receive an SMS shortly to continue with your deposit.",
        },
        bankDetails: {
            bankName: 'Bank Name',
            accountNumber: 'Account Number',
            accountName: 'Account Name',
            referenceCode: {
                label: 'Reference Code',
                message: 'This is the unique code we use to identify your deposit. Remember to include it when making your deposit.',
            },
            clearingTime: {
                label: 'Estimated Clearing Time',
                message: 'It takes about 2 business days for your deposit to be processed.',
            },
        },
        currencies: {
            header: 'Select a currency',
        },
        enterEmail: {
            prompt: 'Enter your email to continue',
            tos: 'By continuing, you agree to the Terms of Service and Privacy Policy',
        },
        enterOtp: {
            prompt: "We've sent you a six-digit code",
        },
        coins: {
            header: 'Select a coin',
        },
        orderSummary: {
            title: 'Order summary',
            changeMethod: 'Change payment method',
            networkFee: 'Network Fee',
            youReceive: 'You receive',
            amountToPay: 'Amount to pay',
            rate: 'Rate',
            serviceFee: 'Processing Fee',
            mobileMoneyNotice: 'Mobile Money transactions take a few minutes to reflect in your account',
            bankTransferNotice: 'Bank transactions take a few minutes to reflect in your account',
            bankNotice: '',
            paymentMethod: 'Payment Method',
            negativeAmountError: 'Your transaction amount minus the fee is less than 0, please enter an amount greater than fee amount',
        },
        sellOrderSummary: {
            title: 'Order summary',
            changeMethod: 'Change payment method',
            sellAmount: 'Sell amount',
            rate: 'Rate',
            serviceFee: 'Processing Fee',
            mobileMoneyNotice: 'Mobile Money transactions take a few minutes to reflect in your account',
            bankTransferNotice: 'Bank Transfer transactions takes 2-3 business days to clear',
            bankNotice: '',
            paymentMethod: 'Payment Method',
            amountReceive: 'You will receive',
        },
        sellPaymentDetails: {
            title: 'Enter your bank account details',
            mobileMoney: 'Enter your mobile money account details',
        },
        sellWalletDetails: {
            amount: 'Amount to send',
            timer: 'Your transaction will expire within ',
            wallet: {
                address: 'Wallet address',
                tag: 'tag',
                coin: 'Coin',
                network: 'Network',
                receive: 'You will receive',
            },
        },
        sellRedirectMessage: 'We will re-direct you back to your app to facilitate your crypto sell in order to continue with your transaction.',
        sellOrderFailed: {
            heading: 'Sorry about this!',
            subheading: "We're not sure what went wrong with your sale. Please try again in a few minutes.",
        },
        sellOrderSent: {
            heading: 'Thanks for your time!',
            subheading: "You'll receive an SMS shortly to continue with your sale.",
            status: {
                awaiting: {
                    title: 'Awaiting crypto send',
                    message: 'We will confirm your order as soon as we have received your crypto',
                },
                received: {
                    title: 'Crypto received',
                    message: '',
                },
                sendingFunds: {
                    title: 'Sending funds to your bank account',
                    message: 'This transfer can take a few minutes to complete.',
                },
                fundsSent: {
                    title: 'Funds sent successfully to bank account',
                    message: '',
                },
            },
            depositNotFound: {
                heading: 'Sorry about this!',
                subheading: "We're not sure what went wrong with your deposit request. Please try again in a few minutes",
                status: {
                    notFound: 'Crypto not found',
                    notice: 'If you have made your deposit and you believe this is inaccurate, please contact support with your proof of payment',
                },
            },
        },
        paymentOptions: {
            sellPrompt: {
                title: 'How do you want to receive payment?',
                subtitle: 'Select the payout method to see more information to proceed',
            },
            buyPrompt: {
                title: 'How do you want to pay?',
                subtitle: 'Select a payment method to see more information to proceed',
            },
            mobileMoney: {
                title: 'Mobile Money',
                notification: 'Mobile Money transactions usually take a few minutes to clear',
            },
            bankTransfer: {
                title: 'Bank Transfer',
                instant: 'Bank Transfers usually clear instantly',
                manual: 'Bank Transfers usually take 2-3 business days to clear',
            },
        },
        miniPay: {
            headerText: 'Processing Error',
            errorText: 'We are unable to process your transaction',
            balanceError: 'You do not have enough funds in your MiniPay wallet to process your sell order. Please top up your balance in your MiniPay app.',
            blockchainError: 'There was an on-chain issue that prevented us from completing your sell order. Please try again.',
        },
        payoutAccounts: {
            manage: {
                heading: 'Saved payout accounts',
                title: 'Manage your payout accounts',
                subtitle: 'You can only have 5 payout accounts saved to your account',
                addPayout: {
                    title: 'Add new payout account',
                    subtitle: 'Add a new payout account for your sell transaction',
                },
            },
            add: {
                heading: 'Add a new account',
                title: 'What payout account do you prefer?',
                subtitle: 'Select a payout account for more information to proceed',
                momo: {
                    heading: 'Your payment details',
                    title: 'Enter your mobile money account details',
                    form: {
                        accountNumber: 'Phone number',
                        accountName: 'Account name',
                        provider: 'Select a provider',
                    },
                },
                bank: {
                    heading: 'Your payment details',
                    title: 'Enter your bank account details',
                    form: {
                        accountNumber: 'Account number',
                        accountBankName: 'Bank name',
                        accountName: 'Account holder name',
                        bankName: 'Bank name',
                        bankSelect: 'Select a bank',
                        branchCode: 'Branch code (optional)',
                    },
                },
            },
            update: {
                heading: 'Your payment details',
            },
            deletePayoutView: {
                heading: 'Delete saved account',
                title: 'Are you sure you want to delete?',
                subtitle: 'Deleting this will remove it from your account. You will not be able to receive funds with it in the future.',
            },
        },
    },
};
